import { ServicesService } from "./implementations/services.service";
import { useStore } from "vuex";

export default defineNuxtPlugin((nuxtApp) => {
  const services = new ServicesService(
    nuxtApp,
    nuxtApp.$axios,
    nuxtApp.$config.public.sgApiUrl,
    nuxtApp.$config.public.sgCmsApi,
    nuxtApp.$config.public.sgCmsImage,
    useStore()
  );

  return {
    provide: {
      services: services,
    },
  };
});
